<template>
	<div>
		<step
			valid
			name="price-table"
			v-if="!isConfiguration"
			:title="!isConfiguration ? 'Kies een oplage' : productTitleString + ' aanpassen'" >
			<price-table />
		</step>
		<step name="configurator-overview" valid>
			<div slot="title" class="h4 hide"/>
			<modal
				title="Productnaam aanpassen"
				button-style="none"
				modal-style="styled"
				:open="openModal">
				<div
					slot="button"
					class="h4 configurator-step__title cursor-pointer"
					@click="openNameModal">
					{{ !isConfiguration ? productTitleString : productTitleString + ' aanpassen' }}
					<svg class="icon icon--small color-gray-500">
						<use xlink:href="#edit" />
					</svg>
				</div>

				<label class="input-label" for="name">Productnaam</label>
				<div
					class="grid grid--gutters grid--center-vertical grid--ms-full mb-s">
					<div class="cell cell--fit">
						<input
							class="input-field input-field--border"
							type="text"
							id="name"
							@input="setConfigurationName"
							v-model="name"
							name="name">
					</div>
					<div class="cell cell--auto">
						<button
							class="button button--cta button--full-width"
							aria-hidden="Naam opslaan"
							@click="closeNameModal">Opslaan</button>
					</div>
				</div>
			</modal>
			<div
				class="h4 hide-ms product-title" v-if="isConfiguration">
				{{ productTitleString }}
			</div>
			<div class="configurator-options__holder configurator-options mv-s">
				<div class="configurator-options__holder-inner">
					<div class="grid grid--1-2 grid--ms-full grid--gutters mb-m">
						<div class="cell cell--40 cell--ms-100">
							<div class="configurator-overview__image-holder ph-l">
								<img
									v-if="!previewUrl"
									:src="iconPath"
									ref="imagePreview"
									class="configurator-overview__image"
									width="500">
								<img
									v-else
									:src="imagePath(iconPath)"
									ref="imagePreview"
									class="configurator-overview__image"
									width="500">
								<div
									v-if="!previewIsLoaded && isPreview"
									class="configurator__loader configurator__loader--overlay">
									<div id="loader" />
								</div>
							</div>
						</div>
						<div class="cell cell--60 cell--ms-100">
							<div class="grid grid--1-2 grid--s-full grid--gutters-s" v-if="check.hasSelectedOptions">
								<div
									class="cell"
									v-if="formatDescription != null">
									<div
										class="configurator-overview__option configurator-overview__option--active cursor-pointer"
										@click="setStepActive('select-format')">
										<p>
											<Strong>Formaat</Strong>
											<svg class="icon">
												<use xlink:href="#edit" />
											</svg>
										</p>
										<p class="configurator-overview__option-name" v-html="formatDescription"/>
									</div>
								</div>
								<div
									v-for="(option, index) in visibleSelectedOptions"
									class="cell"
									:key="index">
									<div
										class="configurator-overview__option configurator-overview__option--active cursor-pointer"
										@click="setStepActive(option.parentGroupId)"
										v-if="!groupLocked(option.parentGroupId)">
										<p>
											<strong>{{ productOptionGroup(option.parentGroupId).name }}</strong>
											<svg class="icon">
												<use xlink:href="#edit" />
											</svg>
										</p>
										<p class="configurator-overview__option-name">
											{{ option.name }}
										</p>
									</div>
									<div
										class="configurator-overview__option"
										v-else>
										<p>
											<strong>{{ productOptionGroup(option.parentGroupId).name }}</strong>
										</p>
										<p class="configurator-overview__option-name">
											{{ option.name }}
										</p>
									</div>
								</div>
								<div
									class="cell"
									v-if="isConfiguration && isEditorProject && configuratorChanged">
									<p><strong>Configuratie aanpassen</strong></p>
									<button
										class="button configurator-overview__option-button--edit"
										@click="setFirstStepActive">
										<svg class="icon">
											<use xlink:href="#edit" />
										</svg>
									</button>
								</div>
								<spine table v-if="configuratorData.hasMultiplePages" />
							</div>
						</div>
					</div>
					<div class="grid grid--1-2 grid--gutters pv-s">
						<div class="cell cell--40 hide-ms"/>
						<div class="cell cell--60 cell--ms-full">
							<div
								class="configurator-overview__price-row flex-space flex-space--between"
								v-if="!getOrderLine.isOffset">
								<p><strong>Oplage</strong></p>
								<amount clean />
							</div>
							<div class="configurator-overview__price-row flex-space flex-space--between" v-else>
								<p><strong>Oplage</strong></p>
								<p><strong>{{ getOrderLine.amount }}</strong> stuks</p>
							</div>
							<p
								class="configurator-overview__price-row--discount color-indigo-600 cursor-pointer"
								v-if="!getOrderLine.isOffset"
								@click="navigateToPriceTable">
								Tip: voordeliger bij een hogere oplage
							</p>
							<hr class="configurator__price-row__linebreak mv-s">
							<div class="configurator-overview__price-row  flex-space flex-space--between">
								<template v-if="!loadingPrice">
									<p><strong>Totaalprijs</strong></p>
									<price />
								</template>
								<template v-else>
									<div class="loading">
										<div />
										<div />
										<div />
									</div>
								</template>
							</div>
						</div>
					</div>

					<div class="description mv-s">
						<p class="description__text">
							Neem voor het uploaden de aanleverspecificaties goed door.
							Dit voorkomt problemen met het uploaden.
						</p>
						<modal
							title="Aanleverspecificaties"
							button-style="descriptionButton"
							modal-style="styled"
							button-text="Aanleverspecificaties"
							v-if="!isConfiguration && !isOffTheShelf">
							<delivery-specification :format="selectedFormat" overview />
						</modal>
					</div>

					<template v-if="!uploadSizeMatchesCustomSize && getUploaderPosition.after">
						<div class="alertbox alertbox--error alertbox mt-s mb-s">
							<svg class="alertbox__icon alertbox__icon--error">
								<use xlink:href="#alert--error" />
							</svg>
							<p class="alertbox__text">
								Uw ingevoerde maatwerk formaat is aangepast naar het formaat van de geüploade PDF.
								Controleer het eindformaat goed voordat u bestelt.
							</p>
						</div>
						<button class="button button--line-grey button--small" @click="resetAllUploads">
							Upload(s) resetten
						</button>
						<br>
					</template>

					<div
						class="alertbox alertbox--notification alertbox mt-s mb-s"
						v-if="showDefaultConfigAlert">
						<svg class="alertbox__icon alertbox__icon--notification">
							<use xlink:href="#alert--info" />
						</svg>
						<p class="alertbox__text">
							Onderstaande configuratie is een standaard configuratie.
							<a
								@click="setFirstStepActive"
								class="link">Klik hier om de configuratie aan te passen.</a>
						</p>
					</div>

					<div
						class="alertbox alertbox--notification alertbox mt-s mb-s"
						v-if="baseProps.isSpecificationConfiguration">
						<svg class="alertbox__icon alertbox__icon--notification">
							<use xlink:href="#alert--info" />
						</svg>
						<p class="alertbox__text">
							<a
								class="link"
								:href="productPageUrl">
								Bekijk alle mogelijke formaten en afwerkingen van dit product
							</a>
						</p>
					</div>
				</div>
			</div>
			<price-table v-if="isConfiguration" overview/>
		</step>
		<quotation />
	</div>
</template>

<script>
import step from "@/components/step/step";
import price from "@/components/element/price";
import priceTable from "@/components/element/price-table";
import amount from "@/components/element/amount";
import spine from "@/components/element/spine";
import modal from "@/components/element/modal";
import deliverySpecification from "@/components/information/delivery-specification";
import quotation from "@/components/overview/quotation";
import { CONFIG } from "@/config";
import { mapState } from "vuex";

export default {
	name: "ConfiguratorOverview",
	data () {
		return {
			openModal: false,
			name: "",
			previewIsLoaded: false,
			isPreview: false,
			placeholderUrl: "/images/svg/placeholder.svg",
			previewImage: null
		};
	},
	components: {
		step,
		price,
		priceTable,
		amount,
		spine,
		modal,
		deliverySpecification,
		quotation
	},
	computed: {
		...mapState(["baseProps"]),
		isConfiguration () {
			return this.$store.getters.getConfiguratorType.isConfiguration;
		},
		configuratorData () {
			return this.$store.getters.getConfiguratorData;
		},
		selectedProduct () {
			return this.$store.getters.getSelectedProduct;
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		selectedOptions () {
			const hiddenOptionGroups = this.selectedFormat.productOptionGroups.reduce((_hiddenOptionGroups, og) => {
				if (og.productOptions.length === 1) {
					_hiddenOptionGroups.push(og.id);
				}
				return _hiddenOptionGroups;
			}, []);

			const selectedOptionsArray = Object.values(
				this.$store.getters.getSelectedOptions
			);

			return selectedOptionsArray.filter(
				o => !hiddenOptionGroups.includes(o.parentGroupId)
			);
		},
		selectedDesign () {
			const _designGroupIdentifier = "Ontwerp";
			const designGroup = this.$store.getters.getSelectedFormat.productOptionGroups
				.find(og => og.name === _designGroupIdentifier);

			if (designGroup) {
				return this.selectedOptions
					.find(o => o.parentGroupId === designGroup.id);
			}
		},
		getSvg () {
			return this.$store.getters.getSvg;
		},
		productSize () {
			return this.$store.getters.getProductSize;
		},
		selectedCustomSize () {
			return this.$store.getters.getCustomSize;
		},
		configuratorChanged () {
			return this.$store.getters.getConfiguratorChanged;
		},
		iconPath () {
			if (this.isOffTheShelf && this.selectedDesign) {
				return this.selectedDesign.iconPath;
			}

			if (this.configuratorData.hasMultipleProducts) {
				return this.selectedProduct.iconPath;
			}

			return this.selectedFormat.iconPath;
		},
		check () {
			return this.$store.getters.checkData;
		},
		formatDescription () {
			return this.$store.getters.getSelectedFormatDescription;
		},
		productTitleString () {
			return this.name !== "" ? this.name : this.selectedFormat.productSize.fullName;
		},
		isCustomSize () {
			return this.$store.getters.isCustomSize;
		},
		previewUrl () {
			return this.$store.getters.getPreviewUrl;
		},
		isEditorProject () {
			return this.$store.getters.isEditorProject;
		},
		getOrderLine () {
			return this.$store.getters.getOrderLine;
		},
		loadingPrice () {
			return this.$store.getters.getLoader.price;
		},
		getAmount () {
			return this.getOrderLine.amount;
		},
		isOffTheShelf () {
			return this.$store.getters.isOffTheShelf;
		},
		forcedOptionGroup () {
			return this.$store.getters.getConfigurationSettings.productGroupIdsForcedByEditor;
		},
		hiddenOptionGroupIds () {
			return this.$store.getters.getHiddenOptionGroupIds;
		},
		visibleSelectedOptions () {
			// Options belonging to a group tagged Hidden are never shown here, unlike groups
			// forced by the editor which still show up read-only (see groupLocked/forcedOptionGroup).
			return this.selectedOptions.filter(option => !this.hiddenOptionGroupIds.includes(option.parentGroupId));
		},
		getUploaderPosition () {
			return this.$store.getters.getUploaderPosition;
		},
		uploadSizeMatchesCustomSize () {
			if (this.$store.getters.uploadsAreComplete && this.isCustomSize) {
				const customSize = this.selectedCustomSize;
				const bleedSize = this.bleedSize(this.productSize).trimmed();

				return (customSize.width === bleedSize.width && customSize.height === bleedSize.height)
					|| (customSize.width === bleedSize.height && customSize.height === bleedSize.width);
			}

			return true;
		},
		config () {
			return CONFIG;
		},
		showDefaultConfigAlert () {
			return this.isConfiguration
				&& (this.isEditorProject && !this.configuratorChanged);
		},
		productPageUrl () {
			return location.href.split("?")[0];
		}
	},
	methods: {
		resetAllUploads () {
			this.isPreview = false;
			this.previewIsLoaded = false;
			this.$store.commit("RESET_ALL_FILE_UPLOADS");
		},
		bleedSize (size) {
			return this.$store.getters.bleedSize(size);
		},
		setStepActive (payload) {
			if (this.groupLocked(payload)) {
				return;
			}
			this.$store.commit("SET_STEP_ACTIVE", payload);
		},
		navigateToPriceTable () {
			if (this.isConfiguration) {
				const el = this.$el.querySelector(".price-overview-grid");
				if (el) {
					el.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			} else {
				this.setStepActive("price-table");
			}
		},
		setFirstStepActive () {
			const nonSelectableGroupIds = this.$store.getters.getNonSelectableOptionGroupIds;
			const filteredOptions = this.selectedOptions.filter(option => !nonSelectableGroupIds.includes(option.parentGroupId));
			this.$store.commit("SET_IS_SPECIFICATION_CONFIGURATION", false);
			this.$store.commit("SET_STEP_ACTIVE", filteredOptions[0].parentGroupId);
		},
		openNameModal () {
			this.openModal = false;

			setTimeout(function () {
				this.openModal = true;
			}.bind(this), 100);
		},
		closeNameModal () {
			this.openModal = false;
		},
		setConfigurationName () {
			if (this.name !== "" || this.name.length) {
				this.$store.commit("SET_CONFIGURATION_NAME", this.name);
			}
		},
		imagePath (iconPath) {
			let result = "";
			if (!this.previewUrl && this.previewUrl === null) {
				result = iconPath;
			} else {
				result = this.placeholderUrl;
				this.isPreview = true;
			}

			if (this.isPreview) {
				let retryAttempt = 1; // ms

				const maxRetryAttempts = 40;
				let handle = setInterval(() => {
					if (retryAttempt === maxRetryAttempts || this.previewIsLoaded) {
						clearInterval(handle);
						this.previewIsLoaded = true;
					}

					let src = this.previewUrl.indexOf("http") !== -1
						? this.previewUrl
						: this.previewUrl;

					if (!this.previewIsLoaded) {
						this.$http.get(src).then(
							response => {
								src += src.indexOf("?") === -1 ? "?" : "&";
								src += "timestamp=" + new Date().getTime();
								this.previewImage = src;
								this.previewIsLoaded = true;
								clearInterval(handle);
							},
							response => {
								this.previewIsLoaded = false;
								this.previewImage = this.placeholderUrl;
							}
						);
					}
					retryAttempt += 1;
				}, 3000 * retryAttempt);
			}

			return this.previewImage || result;
		},
		productOptionGroup (groupId) {
			const productGroupInfo = this.selectedFormat.productOptionGroups.find(g => g.id === groupId);

			return productGroupInfo;
		},
		groupLocked (groupId) {
			return this.forcedOptionGroup.includes(groupId);
		}
	},
	mounted () {
		if (this.isConfiguration) {
			this.$store.commit("SET_STEP_ACTIVE", "configurator-overview");
		}

		document.addEventListener(
			"resetStandardSpecificationConfiguration",
			this.setFirstStepActive);
	},
	beforeDestroy () {
		document.removeEventListener(
			"resetStandardSpecificationConfiguration",
			this.setFirstStepActive);
	}
};
</script>

<style lang="scss">
.price-info {
  padding: 25px 30px;
  margin: 25px 25px 25px 0px;
  border-radius: 5px;
  background: #fff;
}

.configurator-overview__table-icon {
    vertical-align: middle;
}

.configurator-overview__table tr > td:nth-child(2) {
    padding-left: 10px;
}

.configurator-overview__table tr > td:nth-child(3) {
    padding-left: 20px;
}

.icon-holder {
    width: 16px;
    height: 16px;
    background: white;
    border-radius: 50%;
    fill: #438db4;
}

.overview-main-image {
  flex: 0 1 36%;
  max-width: 36%;
  padding: 25px;
}

.overview-main-information {
  padding: 3rem;
}

.configurator-options__holder {
  position: relative;
  border-radius: 5px;
}
.configurator-options__holder-inner {
  overflow: hidden;
}

.specifications-button {
  font-size: 1.3rem;
  padding: 8px 15px;
  display: block;
  width: 100%;
}

.configurator-overview__option {
	.icon {
		width: 16px;
		height: 16px;
		color: var(--cfg-primary-accent);
	}

	&--active:hover {
		.icon {
			color: var(--cfg-primary);
		}
		.configurator-overview__option-name {
			text-decoration: underline;
		}
	}
}

.configurator-overview__image-holder {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	background:var(--cfg-primary-tint-alt);
	border-radius: 8px;
}

.configurator-overview__image {
	width: 100%;
	max-width: 210px;
	margin: 35px auto;
	display: block;
}

.configurator-overview__price-row--discount {
	&:hover {
		text-decoration: underline;
	}
}

@media screen and (max-width: 725px) {
	.configurator-overview__image {
	width: 100%;
	max-width: 125px;
	margin: 24px auto;
	display: block;
}
}

@media screen and (max-width: 1200px) {
  .price-info {
    margin: 0 25px 25px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/overview/configurator-overview.vue